import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(theme => ({
	menu: {
		alignItems: "center",
		display: "flex",
		flexDirection: "column",
		gap: theme.spacing(2),
		order: 1,
		"& ul": {
			alignItems: "center",
			display: "flex",
			flexDirection: "column",
			gap: theme.spacing(2),
			[theme.breakpoints.up("md")]: {
				gap: theme.spacing(3)
			}
		},
		[theme.breakpoints.up("md")]: {
			flexDirection: "row",
			gap: theme.spacing(3),
			order: 2,
			"& ul": {
				flexDirection: "row"
			}
		}
	},
	copyright: {
		color: theme.palette?.text?.primary,
		textAlign: "center"
	},
	item: {
		"& a": {
			color: theme.palette?.text?.primary,
			transition: "color 250ms ease",
			"&:hover": {
				color: theme.palette?.text?.secondary
			}
		}
	}
}));

export default styles;
